import * as React from 'react';
import { CurrentClientIdType } from '../current-client-route-state-context';

export type CurrentClientStorageDispatchContextType =
    | ((newClientId: CurrentClientIdType) => void)
    | undefined;

export const CurrentClientStorageDispatchContext = React.createContext<CurrentClientStorageDispatchContextType>(undefined);
CurrentClientStorageDispatchContext.displayName = 'CurrentClientStorageDispatchContext';
